import { createSelector } from 'reselect';

export const movingTruckLandingSelector = createSelector(
	(state) => state.pageMeta,
	(state) => state.content.movingTruckPSP,
	(state) => state.facilities.byId,
	(state) => state.content.truckResultsSearchId,
	(state) => state.content.penskeResultsSearchId,
	(
		pageMeta,
		movingTruckPSP,
		facilities,
		truckResultsSearchId,
		penskeResultsSearchId
	) => ({
		phone: pageMeta.phone,
		location: {
			city: movingTruckPSP.city,
			state: movingTruckPSP.state
		},
		penskeResultsSearchId,
		penskeFacilities: (
			movingTruckPSP.penskeResults &&
				movingTruckPSP.penskeResults.map((facilityId) => facilities[facilityId])
		),
		penskeResultsURL: movingTruckPSP.penskeResultsURL,
		truckResultsSearchId,
		truckFacilities: (
			movingTruckPSP.truckResults &&
				movingTruckPSP.truckResults.map((facilityId) => facilities[facilityId])
		),
		truckResultsURL: movingTruckPSP.truckResultsURL,
		bellhopsURL: movingTruckPSP.bellhopsURL,
		penskeURL: movingTruckPSP.penskeURL,
		isBellhopsMarket: movingTruckPSP.isBellhopsMarket
	})
);

export const movingTruckCLPSelector = createSelector(
	(state) => state.pageMeta,
	(state) => state.content.movingTruckPSP,
	(state) => state.facilities.byId,
	(
		pageMeta,
		movingTruckPSP,
		facilities
	) => ({
		phone: pageMeta.phone,
		location: {
			city: movingTruckPSP.city,
			state: movingTruckPSP.state
		},
		truckFacilities: movingTruckPSP.truckResults.map((facilityId) => facilities[facilityId]),
		truckResultsURL: movingTruckPSP.truckResultsURL,
		bellhopsURL: movingTruckPSP.bellhopsURL,
		penskeURL: movingTruckPSP.penskeURL,
		isBellhopsMarket: movingTruckPSP.isBellhopsMarket,
		content: movingTruckPSP.content,
		canonicalUrl: movingTruckPSP.canonicalUrl
	})
);

export const portableStoragePSPCLPSelector = createSelector(
	(state) => state.content.portableStoragePSPCLP,
	(portableStoragePSPCLP) => ({
		content: portableStoragePSPCLP.content || {},
		canonicalUrl: portableStoragePSPCLP.canonicalUrl,
		location: portableStoragePSPCLP.location || {}
	})
);
